"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 2.2.0
 */
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var form_service_1 = require("./form.service");
var interpreter_1 = require("../interpreter");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var of_1 = require("rxjs/observable/of");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var HttpFormService = /** @class */ (function (_super) {
    __extends(HttpFormService, _super);
    function HttpFormService(http, applicationPropertyService, layoutReadingService, layoutWritingService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.layoutReadingService = layoutReadingService;
        _this.layoutWritingService = layoutWritingService;
        _this.URL_ALL_FORMS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/forms"], ["", "/forms"])), 'serviceUrl');
        _this.URL_ALL_FORMS_WITH_PREFIX = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/", "/forms"], ["", "/", "/forms"])), 'serviceUrl', 'prefix');
        _this.URL_ONE_FORM_BY_ID = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", "/forms/", ""], ["", "/forms/", ""])), 'serviceUrl', 'formId');
        _this.URL_ALL_FORM_BY_CATEGORY = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", "/forms?categorySystemName=", "&typeId=", ""], ["", "/forms?categorySystemName=", "&typeId=", ""])), 'serviceUrl', 'categoryName', 'formType');
        _this.URL_ALL_FORM_BY_CATEGORY_SUBCATEGORY = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", "/forms?categorySystemName=", "&typeId=", "&subCategorySystemName=", ""], ["", "/forms?categorySystemName=", "&typeId=", "&subCategorySystemName=", ""])), 'serviceUrl', 'categoryName', 'formType', 'subCategorySystemName');
        _this.FORM_SERVICE_KEY = 'form-service-url';
        _this.formServiceUrl = new ReplaySubject_1.ReplaySubject(1);
        applicationPropertyService
            .getProperty(_this.FORM_SERVICE_KEY)
            .then(function (url) {
            _this.formServiceUrl.next(url);
            _this.formServiceUrl.complete();
        });
        return _this;
    }
    HttpFormService.prototype.loadForm = function (formName, formId, categoryName) {
        return this.loadFormById(formId);
    };
    HttpFormService.prototype.addNewForm = function (formData) {
        var _this = this;
        var formCategory = formData.formEntityTypeId === FormEntityType.MAIN_FORM
            ? formData.categorySystemName
            : formData.subCategorySystemName;
        return this.formServiceUrl.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this.http.post(_this.URL_ALL_FORMS.replaceTemplate({ serviceUrl: serviceUrl }), {
                id: formData.id,
                data: _this.layoutWritingService.writeForm(formData.model, formCategory),
                typeId: formData.type,
                formSystemName: formData.model.formName,
                categorySystemName: formData.categorySystemName,
                subCategorySystemName: formData.subCategorySystemName,
                name: formData.name,
                formEntityTypeId: formData.formEntityTypeId,
                description: formData.description,
                prefix: formData.prefix,
            });
        }), operators_1.switchMap(function (formJson) {
            return _this.layoutReadingService
                .readForm(formJson.data, formData.model.category)
                .pipe(operators_1.map(function (model) {
                return {
                    id: formJson.id,
                    model: model,
                    type: formJson.typeId,
                    description: formJson.description,
                    formEntityTypeId: formJson.formEntityTypeId,
                    name: formJson.name,
                    categorySystemName: formJson.categorySystemName,
                    subCategorySystemName: formJson.subCategorySystemName,
                    prefix: formJson.prefix,
                };
            }));
        }));
    };
    HttpFormService.prototype.updateForm = function (formData) {
        return this.updateFormJson(formData);
    };
    HttpFormService.prototype.removeForm = function (formId) {
        var _this = this;
        return this.formServiceUrl.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this.http.delete(_this.URL_ONE_FORM_BY_ID.replaceTemplate({
                serviceUrl: serviceUrl,
                formId: formId.toString(),
            }));
        }));
    };
    HttpFormService.prototype.allFormsByCategoryAndType = function (categoryName, type) {
        var _this = this;
        return this.formServiceUrl.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this.http.get(_this.URL_ALL_FORM_BY_CATEGORY.replaceTemplate({
                serviceUrl: serviceUrl,
                categoryName: categoryName,
                formType: type.valueOf().toString(),
            }));
        }), operators_1.switchMap(function (formJsons) {
            return combineLatest_1.combineLatest(formJsons.map(_this.extractForm));
        }));
    };
    HttpFormService.prototype.allSubFormsByCategoryAndType = function (categoryName, subCategoryName, type) {
        var _this = this;
        return this.formServiceUrl.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this.http.get(_this.URL_ALL_FORM_BY_CATEGORY_SUBCATEGORY.replaceTemplate({
                serviceUrl: serviceUrl,
                categoryName: categoryName,
                subCategorySystemName: subCategoryName,
                formType: type.valueOf().toString(),
            }));
        }), operators_1.switchMap(function (formJsons) {
            if (formJsons && formJsons.length > 0) {
                return combineLatest_1.combineLatest(formJsons.map(_this.extractForm));
            }
            else {
                return of_1.of([]);
            }
        }));
    };
    HttpFormService.prototype.loadFormTypeId = function (formName, formId, categoryName) {
        var _this = this;
        return this.formServiceUrl.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this.http
                .get(_this.URL_ONE_FORM_BY_ID.replaceTemplate({
                serviceUrl: serviceUrl,
                formId: formId.toString(),
            }))
                .pipe(operators_1.map(function (formJson) {
                return formJson.typeId;
            }));
        }));
    };
    HttpFormService.prototype.updateFormJson = function (formData) {
        var _this = this;
        var formCategory = formData.formEntityTypeId === FormEntityType.SUB_FORM
            ? formData.subCategorySystemName
            : formData.categorySystemName;
        return this.formServiceUrl.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this.http.patch(_this.URL_ALL_FORMS.replaceTemplate({ serviceUrl: serviceUrl }), {
                id: formData.id,
                data: _this.layoutWritingService.writeForm(formData.model, formCategory),
                categorySystemName: formData.categorySystemName,
                typeId: formData.type,
                formSystemName: formData.model.formName,
                subCategorySystemName: formData.subCategorySystemName,
                name: formData.name,
                formEntityTypeId: formData.formEntityTypeId,
                description: formData.description,
                prefix: formData.prefix,
            });
        }), operators_1.switchMap(function (formJson) {
            return _this.layoutReadingService
                .readForm(formJson.data, formData.model.category)
                .pipe(operators_1.map(function (model) {
                return {
                    id: formJson.id,
                    model: model,
                    type: formJson.typeId,
                    description: formJson.description,
                    formEntityTypeId: formJson.formEntityTypeId,
                    name: formJson.name,
                    categorySystemName: formData.categorySystemName,
                    subCategorySystemName: formJson.subCategorySystemName,
                    prefix: formJson.prefix,
                };
            }));
        }));
    };
    HttpFormService.prototype.fullUpdateForm = function (formData) {
        var _this = this;
        var formCategory = formData.formEntityTypeId === FormEntityType.SUB_FORM
            ? formData.subCategorySystemName
            : formData.categorySystemName;
        var prefix = formData.prefix;
        return this.formServiceUrl.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this.http.put(prefix
                ? _this.URL_ALL_FORMS_WITH_PREFIX.replaceTemplate({
                    serviceUrl: serviceUrl,
                    prefix: prefix,
                })
                : _this.URL_ALL_FORMS.replaceTemplate({ serviceUrl: serviceUrl }), {
                id: formData.id,
                data: _this.layoutWritingService.writeForm(formData.model, formCategory),
                categorySystemName: formData.categorySystemName,
                typeId: formData.type,
                formSystemName: formData.model.formName,
                subCategorySystemName: formData.subCategorySystemName,
                name: formData.name,
                formEntityTypeId: formData.formEntityTypeId,
                description: formData.description,
                prefix: formData.prefix,
            });
        }), operators_1.switchMap(function (formJson) {
            return _this.layoutReadingService
                .readForm(formJson.data, formData.model.category)
                .pipe(operators_1.map(function (model) {
                return {
                    id: formJson.id,
                    model: model,
                    type: formJson.typeId,
                    description: formJson.description,
                    formEntityTypeId: formJson.formEntityTypeId,
                    name: formJson.name,
                    categorySystemName: formData.categorySystemName,
                    subCategorySystemName: formJson.subCategorySystemName,
                    prefix: formJson.prefix,
                };
            }));
        }));
    };
    HttpFormService.prototype.loadFormById = function (formId) {
        var _this = this;
        return this.formServiceUrl.pipe(operators_1.switchMap(function (serviceUrl) {
            return _this.http
                .get(_this.URL_ONE_FORM_BY_ID.replaceTemplate({
                serviceUrl: serviceUrl,
                formId: formId.toString(),
            }))
                .pipe(operators_1.switchMap(function (formJson) {
                return _this.extractForm(formJson);
            }));
        }));
    };
    HttpFormService.prototype.extractForm = function (formJson) {
        var formCategory = formJson.formEntityTypeId === FormEntityType.SUB_FORM
            ? formJson.subCategorySystemName
            : formJson.categorySystemName;
        if (formJson.data && formJson.data !== '') {
            return this.layoutReadingService
                .readForm(formJson.data, formCategory)
                .pipe(operators_1.map(function (model) {
                return {
                    id: formJson.id,
                    model: model,
                    type: formJson.typeId,
                    description: formJson.description,
                    formEntityTypeId: formJson.formEntityTypeId,
                    name: formJson.name,
                    categorySystemName: formJson.categorySystemName,
                    subCategorySystemName: formJson.subCategorySystemName,
                    prefix: formJson.prefix,
                };
            }));
        }
        return of_1.of({
            id: formJson.id,
            model: interpreter_1.FormLayoutModel.emptyModel(formJson, formCategory),
            type: formJson.typeId,
            description: formJson.description,
            formEntityTypeId: formJson.formEntityTypeId,
            name: formJson.name,
            categorySystemName: formJson.categorySystemName,
            subCategorySystemName: formJson.subCategorySystemName,
            prefix: formJson.prefix,
        });
    };
    HttpFormService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            interpreter_1.LayoutReadingService,
            interpreter_1.LayoutWritingService])
    ], HttpFormService);
    return HttpFormService;
}(form_service_1.FormService));
exports.HttpFormService = HttpFormService;
var FormEntityType;
(function (FormEntityType) {
    FormEntityType[FormEntityType["MAIN_FORM"] = 1] = "MAIN_FORM";
    FormEntityType[FormEntityType["SUB_FORM"] = 2] = "SUB_FORM";
    FormEntityType[FormEntityType["WORKFLOW_FORM"] = 3] = "WORKFLOW_FORM";
})(FormEntityType = exports.FormEntityType || (exports.FormEntityType = {}));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=http-form.service.js.map